import { Component, Inject, TemplateRef } from '@angular/core';
import { PagerService } from '../../services/shared/pager.service';
import { SupplierTicketService } from '../../services/SupplierTicket/SupplierTicket.service';
import { SupplierTicket, TicketReply } from '../../models/SupplierTicket/SupplierTicket-model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { NotificationService } from '../../services/notification/notification.service';
import { Role } from '../../models/shared/role.model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from "@angular/router";
import { ProfileService } from '../../services/profile/profile.service';
import { forEach } from '@angular/router/src/utils/collection';
@Component({
  selector: 'app-SupplierTicket-list',
  templateUrl: './SupplierTicket-list.component.html',
  styleUrls: ['./SupplierTicket-list.component.css']
})
/** SupplierTicket-List component*/
export class SupplierTicketListComponent {
  public SupplierTicketList: SupplierTicket[];
  public SupplierTicket = new SupplierTicket();
  public TicketReply = new TicketReply();
  public Roles: Role[];
  SupplierTicketisActive: string;
  type: any;
  // pager object
  pager: any = {};
  searchQuery: string;
  fileToUpload: File;
  fd = new FormData();
 // blogCategoryId: number = 0;
  selectedFile: string;
  searchKeyword: string;
  From: string;
  To: string;
  
  Priority: string;
  currentUserID: number;
  CurrentTicketID: number;
  i: number;
  StatusId: number;
  Department: string;
  Reply: string;
  pageSize: number;
  // paged items
  pagedItems: any[];
  filteredItems: any[];
  public departmentArray: any;
  public statusArray: any;
  public statusArrayModel: any;
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  StatusChangeRemarks: any = {};
  StatusID: string;
  /** coupons-list ctor */
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  constructor(private readonly SupplierTicketsService: SupplierTicketService,

    private readonly utilitiesService: UtilitiesService,
    private modalService: BsModalService,
    public toastr: ToastsManager,
    private readonly profileService: ProfileService,
    private readonly router: Router,
    private readonly pagerService: PagerService) {
    this.StatusID = "";
    this.Department = "";
    this.Priority = "";
    this.StatusId = 0;
    this.getSupplierTickets();
    this.pageSize = 10;
    this.getSupplierTickets();
    this.GetRowsPerPageList();
    this.GetDepartments();
    this.GetStatus();
    this.profileService.getProfile().subscribe(
      data => {
        
        if (data) {
          this.currentUserID = data.userID;
          
        }
        else {
          this.currentUserID = 0;
        }
      });
    //this.GetCustomerTypes();
  }


  deleteSupplierTicket(id) {

    var ans = confirm("Are you sure to delete this supplier ticket?");
    if (ans) {
      this.SupplierTicketsService.deleteSupplierTicket(id);
      setTimeout(() => {
        this.getSupplierTickets();
      }, 2000);
    }
  }
  getSupplierTickets() {

    this.SupplierTicketsService.getSupplierTicket().subscribe(
      data => {
        
        this.SupplierTicketList = data
        this.filteredItems = data;
      }

    )
  }
  GetDepartments() {
    this.SupplierTicketsService.getDepartments().subscribe(
      data => {
        this.departmentArray = data;

      }
    )
  }
  GetStatus() {
    this.SupplierTicketsService.getStatus().subscribe(
      data => {
        this.statusArray = data;

      }
    )
  }

  openModal(template: TemplateRef<any>, id) {
    
    this.SupplierTicketsService.getStatus().subscribe(
      data => {
        this.getSupplierTicketById(id);
        this.statusArrayModel = data;
    
        
        if (data) {
          this.modalRef = this.modalService.show(template, this.config);
        }

      }
    )
    //this.SupplierTicketsService.getCustomerInfo(id).subscribe(
    //  data => {
    //    if (data) {
    //      this.customer = data;
    //      if (this.customer.profileImagePath == null) {
    //        this.customer.profileImagePath = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";
    //      }
    //      this.modalRef = this.modalService.show(template, this.config);
    //    }
    //  }
    //)

  }
  setPage(page: number) {

    // get pager object from service
    this.pager = this.pagerService.getPager(this.SupplierTicketList.length, page, this.pageSize);

    // get current page of items
    this.pagedItems = this.SupplierTicketList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {

    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.SupplierTicketList, searchText);

    } else {
      this.filteredItems = this.SupplierTicketList;
    }
  }
  getSupplierTicketById(id: string) {
    this.SupplierTicketsService.getSupplierTicketById(id).subscribe(
      data => {
        this.StatusID = data.statusID;
        this.StatusChangeRemarks = data.statusChangeRemarks;
        this.SupplierTicket = data;
        this.CurrentTicketID = data.id;
      }
    )
  }
  ngReply() {
    
    this.TicketReply.SupplierTicketID = this.CurrentTicketID;
    this.TicketReply.ReplyMessage = this.Reply;
    this.TicketReply.ReplyBy = this.currentUserID;

    this.fd.append("TicketReply", JSON.stringify(this.TicketReply));
    this.SupplierTicketsService.addTicketReply(this.fd).subscribe(
      data => {
        if (data) {
          this.toastr.success('Reply sent successfully.', 'Success');
          this.Reply = "";
          setTimeout(() => {
          //  this.router.navigate(["/SupplierTicket-list"]);
          }, 2000);
          this.modalRef.hide();
          this.getSupplierTickets();
          this.SupplierTicket.Department = "";
          this.SupplierTicket.StatusID = "";
        }
        else {
          this.toastr.error('Error occurred. Please try again', 'Success');

        }
        this.fd = new FormData();

      });

  }
  ngSubmit() {
    

    this.SupplierTicket.StatusID = this.StatusID;
    this.SupplierTicket.StatusChangeRemarks = this.StatusChangeRemarks;

    this.SupplierTicketsService.updateSupplierTicket(this.SupplierTicket).subscribe(
      data => {
        if (data) {
          this.toastr.success('Remarks added successfully.', 'Success');
          setTimeout(() => {
            this.router.navigate(["/SupplierTicket-list"]);
          }, 2000);
          this.modalRef.hide();
          this.getSupplierTickets();
          this.SupplierTicket.Department = "";
          this.SupplierTicket.StatusID = "";
        }
        else {
          this.toastr.error('Error occurred. Please try again', 'Success');

        }

      });
  }
  UploadImages(file) {
    
      

      if (file.length === 0)
        return;

      for (let f of file)
        this.fd.append(f.name, f);




      //this.fileToUpload = file.item(0);
      
      //this.fd.append("file", this.fileToUpload);
      //////Show image preview
      //var reader = new FileReader();
      //reader.onload = (event: any) => {
      //  this.selectedFile = event.target.result;
      //}
      //reader.readAsDataURL(this.fileToUpload);
    
  }


  
  cancelReply() {
    this.Reply = "";
    this.modalRef.hide();
  }
  cancelStatusUpdate() {
    this.SupplierTicket.StatusChangeRemarks = "";
    this.modalRef.hide();
  }
  OnFilterChange() {
    
    this.filteredItems = this.SupplierTicketList;
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }

    if (this.Department != "" && this.Department != null) {
      this.filteredItems = this.filteredItems.filter(s => s.department == this.Department);

    }
    if (this.Priority != "" && this.Priority != null) {
      this.filteredItems = this.filteredItems.filter(s => s.priority == this.Priority);

    }
    if (this.StatusId > 0) {
      this.filteredItems = this.filteredItems.filter(s => s.statusID == this.StatusId);

    }


  }
  searchDate() {
    
    this.filteredItems = this.SupplierTicketList;
    const startDate = this.From;
    
    const endDate = this.To;
    //for (this.i = 0; this.i < this.filteredItems.length; this.i++) {
    
    this.filteredItems = this.filteredItems.filter(
      m => new Date(m.createDateTime) >= new Date(startDate) && new Date(m.createDateTime) <= new Date(endDate)
 
      );
    
  //  }
  

   

  }


  
}



// WEBPACK FOOTER //
// ./src/app/SupplierTicket/SupplierTicket-list/SupplierTicket-list.component.ts